<nav backgroundColor="accent" color="warn" mat-align-tabs="center" mat-tab-nav-bar [tabPanel]="tabPanel"
   mat-stretch-tabs="false">

   <a (click)="activeLink = '/setup/system/config'" [active]="activeLink === '/setup/system/config'"
      [routerLink]="'/setup/system/config'" mat-tab-link>System Config</a>
   <a (click)="activeLink = '/setup/system/webhooks'" [active]="activeLink === '/setup/system/webhooks'"
      [routerLink]="'/setup/system/webhooks'" mat-tab-link>Web Hooks</a>
   <!--  <a mat-tab-link [routerLink]="'/setup/system/audit'"-->
   <!--     (click)="activeLink = '/setup/system/audit'"-->
   <!--     [active]="activeLink === '/setup/system/audit'"-->
   <!--  >Audit Log</a>-->
</nav>
<mat-tab-nav-panel #tabPanel>
   <router-outlet></router-outlet>
</mat-tab-nav-panel>